export default class FieldSet
{
  fields = {};
  constructor(form, el) {
    this.form = form;
    this.el = el;
  }

  getElement(){
    return this.el;
  }

  getForm(){
    return this.form
  }

  addField(name, field){
    this.fields[name] = field;
  }

  getField(name){
    return this.fields[name]
  }

  getFields(){
    return this.fields;
  }

}
